import { formatTicker } from '@toggle/toggle';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { AssetLogoContainer } from '~/components/asset-logo-container/AssetLogoContainer';
import { useNavigateToAssetOverview } from '~/hooks/use-navigate-to-asset-overview/useNavigateToAssetOverview';
import { RatingPill } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/rating-pill/RatingPill';

import { PriceChange } from '../PriceChange';
import { CompanyCardProps } from './company-card-types';
import * as S from './CompanyCard.styles';

export const SecondaryCompanyCard = ({ company, entity }: CompanyCardProps) => {
  const { t } = useTranslation(['earnings']);
  const { navigateToPage } = useNavigateToAssetOverview();

  return (
    <S.Root onClick={() => navigateToPage({ entityTag: company.entity_tag })}>
      <S.HeaderWrapper>
        <S.AssetDetailsWrapper
          onClick={() => navigateToPage({ entityTag: company.entity_tag })}
        >
          <AssetLogoContainer size={40} entity={entity} />
          <S.AssetNameWrapper>
            <S.AssetNameLabel>
              {entity.name_short || entity.name}
            </S.AssetNameLabel>
            <S.FlexWrapper>
              <S.AssetTickerLabel>{formatTicker(entity)}</S.AssetTickerLabel>
              <PriceChange companyData={entity} />
            </S.FlexWrapper>
          </S.AssetNameWrapper>
        </S.AssetDetailsWrapper>
        <RatingPill rating={company.rating} />
      </S.HeaderWrapper>
      <S.DescriptionLabel>{company.description}</S.DescriptionLabel>
      {company.relationship && (
        <S.RelationLabel>{`${t(
          'earnings:earningsInsight.drawer.earningsPreview.relationship'
        )} ${company.relationship}`}</S.RelationLabel>
      )}
    </S.Root>
  );
};
